import { Flex, Heading, Button, Text, Box } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

const GoalsHeader = ({ onAddGoal }) => {
  const { t } = useTranslation('goals');

  return (
    <>
      <Flex justify="between" align="center">
        <Flex direction="column">
          <Heading size="6" m="0">
            {t('title')}
          </Heading>
        </Flex>
        <Button size="3" variant="solid" onClick={onAddGoal}>
          <i className="fa-solid fa-plus" />
          {t('addGoal')}
        </Button>
      </Flex>
      <Flex justify="center">
        <Box
          style={{
            backgroundColor: 'var(--blue-contrast)',
            borderRadius: 'var(--radius-3)',
            border: '1px solid var(--gray-4)',
          }}
          width="100%"
          p="4"
        >
          <Text size="2">{t('subheader')}</Text>
        </Box>
      </Flex>
    </>
  );
};

export default GoalsHeader;
